import { GhostProvider } from './../../providers/ghost/ghost';
import { Post } from './../../models/ghost/Post';
import { Component, Input } from '@angular/core';

/**
 * Generated class for the GlossaryComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'glossary',
  templateUrl: 'glossary.html'
})
export class GlossaryComponent {

  entries: any[];
  currentPageClass = this;
  triggerAlphaScrollChange: number = 0;
  constructor(public ghost: GhostProvider) {
    let posts = this.posts.posts;

    this.entries = posts;

    this.entries.sort((a, b) => {
      return a.title.localeCompare(b.title);
    })
    // for(let post of posts){
    //   let found = false;
    //   for(let letter of this.glossary){
    //     if(letter.key == post.title.charAt(0).toLocaleUpperCase()){
    //       letter.entries.push(post);
    //       found = true;
    //       break;
    //     }
    //   }
    //   if(!found){
    //     this.glossary[0].entries.push(post);
    //   }
    // }
  }

  glossary = [
    {key: '#', entries: []},
    {key: 'A', entries: []},
    {key: 'B', entries: []},
    {key: 'C', entries: []},
    {key: 'D', entries: []},
    {key: 'E', entries: []},
    {key: 'F', entries: []},
    {key: 'G', entries: []},
    {key: 'H', entries: []},
    {key: 'I', entries: []},
    {key: 'J', entries: []},
    {key: 'K', entries: []},
    {key: 'L', entries: []},
    {key: 'M', entries: []},
    {key: 'N', entries: []},
    {key: 'O', entries: []},
    {key: 'P', entries: []},
    {key: 'Q', entries: []},
    {key: 'R', entries: []},
    {key: 'S', entries: []},
    {key: 'T', entries: []},
    {key: 'U', entries: []},
    {key: 'V', entries: []},
    {key: 'W', entries: []},
    {key: 'X', entries: []},
    {key: 'Y', entries: []},
    {key: 'Z', entries: []}
  ]

  posts =
    {
      "posts": [
          {
              "id": "5b42cc1eded32719b2342aec",
              "uuid": "36831cfa-c2ad-45d9-83f6-2ff5259ef4d7",
              "title": "Augur Gearing Up For Mainnet Launch",
              "slug": "augur-gearing-up-for-mainnet-launch",
              "html": "<div class=\"kg-card-markdown\"><p>Augur (REP), a peer-to-peer prediction market platform, is set to launch its main network on July 9th. They raised $5.5 million in 2015 as one of the earliest ICO’s on the Ethereum blockchain and has been under development since. The platform allows users to create prediction markets on the outcomes of future events, they can create markets for an event with a designated reporter and traders can buy shares on the probable outcomes.</p>\n<p>The platform has an inbuilt conflict resolution model that incentivizes REP token holders to correct any misinformation to ensure the accuracy of the real world information at hand and is done so completely peer-to-peer with no centralized party. Augur is heavily undervalued right now at $34.25 usd (508,000 sats).</p>\n</div>",
              "feature_image": "/content/images/2018/07/unnamed-6.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-07-09T02:44:46.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-07-09T02:48:40.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-07-09T02:48:11.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Augur (REP), a peer-to-peer prediction market platform, is set to launch its main network on July 9th. They raised $5.5 million in 2015 as one of the earliest ICO’s on the Ethereum blockchain and has been under development since.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/augur-gearing-up-for-mainnet-launch/",
              "comment_id": "5b42cc1eded32719b2342aec"
          },
          {
              "id": "5b304e66ded32719b2342ad7",
              "uuid": "ed36165b-9832-42ce-9b1a-ceecdb5cb154",
              "title": "Walmart Awarded Patent For Medical Record Blockchain",
              "slug": "walmart-awarded-patent-for-medical-record-blockchain",
              "html": "<div class=\"kg-card-markdown\"><p>U.S. retail giant Walmart has been awarded a patent for a system that would store medical records on a blockchain from a wearable device. The system will allow medical professionals to retrieve medical data from a patient that is unable to communicate.</p>\n<p>The patient’s medical records will be stored on a blockchain and be accessible by a device worn by the patient that first responders could access with an RFID scanner. The medical records could also be shared with hospitals and other entities in the event that a patient is transported to a different facility, their records will arrive before they do.</p>\n</div>",
              "feature_image": "/content/images/2018/06/unnamed-5-1.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-06-25T02:07:34.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-06-25T02:10:56.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-06-25T02:10:56.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "U.S. retail giant Walmart has been awarded a patent for a system that would store medical records on a blockchain from a wearable device. The system will allow medical professionals to retrieve medical data from a patient that is unable to communicate. ",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/walmart-awarded-patent-for-medical-record-blockchain/",
              "comment_id": "5b304e66ded32719b2342ad7"
          },
          {
              "id": "5b304c80ded32719b2342ac1",
              "uuid": "02cfe6c8-ae59-43b0-8fe6-8d30f3c2347c",
              "title": "Tencent and Chinese Officials Forming Blockchain Security Alliance",
              "slug": "tencent-and-chinese-officials-forming-blockchain-security-alliance",
              "html": "<div class=\"kg-card-markdown\"><p>Chinese officials are partnering with tech giant Tencent on the formation of a new China Blockchain Security Alliance. The aim is to promote security in the blockchain industry.</p>\n<p>The alliance will consist of Tencent’s security arm, the China Technology Market Association (CTMA), the China Blockchain Application Research Center, and 20 other public and private institutions, including government advisory agencies, network security firms and blockchain-related organizations. They will establish a long term strategy for the overall development of the blockchain space as China continues to be a key instrument in the advancements of blockchain tech</p>\n</div>",
              "feature_image": "/content/images/2018/06/unnamed-4-1.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-06-25T01:59:28.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-06-25T02:04:41.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-06-25T02:04:41.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Chinese officials are partnering with tech giant Tencent on the formation of a new China Blockchain Security Alliance. The aim is to promote security in the blockchain industry. ",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/tencent-and-chinese-officials-forming-blockchain-security-alliance/",
              "comment_id": "5b304c80ded32719b2342ac1"
          },
          {
              "id": "5b304b66ded32719b2342aad",
              "uuid": "5ac1adfd-3c2c-46fe-b0d4-fa0a4c07ee4e",
              "title": "Enigma To Partner With Intel",
              "slug": "enigma-to-partner-with-intel",
              "html": "<div class=\"kg-card-markdown\"><p>Enigma, a decentralized application platform will partner with Intel on privacy research as it prepares to launch its blockchain testnet.</p>\n<p>The collaboration would focus on research and development efforts to advance development of privacy preserving computation technologies and aims to provide the first environment for scalable end-to-end DApps using bespoke privacy technology to protect data while still allowing computation on top of it. This move is just the latest from Intel further advancing its involvement with blockchain</p>\n</div>",
              "feature_image": "/content/images/2018/06/unnamed-3-2.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-06-25T01:54:46.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-06-25T01:58:28.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-06-25T01:58:28.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Enigma, a decentralized application platform will partner with Intel on privacy research as it prepares to launch its blockchain testnet.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/enigma-to-partner-with-intel/",
              "comment_id": "5b304b66ded32719b2342aad"
          },
          {
              "id": "5b304954ded32719b2342a96",
              "uuid": "60f7d540-ef34-4c40-9166-56e1df0d9383",
              "title": "Bithumb Hacked",
              "slug": "bithumb-hacked",
              "html": "<div class=\"kg-card-markdown\"><p>The sixth largest exchange by trading volume Bithumb, a south-Korean exchange was hacked on Wednesday with around 35 billion Korean won (31 million usd) being stolen. Details of the stolen coins have not yet been released but it’s reported the hackers were targeting ripple (XRP).</p>\n<p>Bithumb accounts for nearly 10% of all xrp trading volume worldwide. Also it has been documented that Bithumb attempted a security enhancement checkup on June 16, days before the hack which clearly failed. They have been moving users holdings to cold storage for safety and have announced that they will pay back what has been stolen to their users</p>\n</div>",
              "feature_image": "/content/images/2018/06/unnamed-2-2.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-06-25T01:45:56.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-06-25T01:48:48.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-06-25T01:48:48.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "The sixth largest exchange by trading volume Bithumb, a south-Korean exchange was hacked on Wednesday with around 35 billion Korean won (31 million usd) being stolen. Details of the stolen coins have not yet been released but it’s reported the hackers were targeting ripple (XRP). ",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/bithumb-hacked/",
              "comment_id": "5b304954ded32719b2342a96"
          },
          {
              "id": "5b30480fded32719b2342a81",
              "uuid": "7485e2e0-66b5-46b4-a392-2db1bc938039",
              "title": "Square Gains Bitlicense",
              "slug": "square-gains-bitlicense",
              "html": "<div class=\"kg-card-markdown\"><p>Financial service provider Square has received a BitLicense from the New York Department of Financial Services and As a result, Bitcoin trading is now available to New York users of Square’s Cash App.</p>\n<p>With Square’s Point of Sale (PoS) network, adding a Bitcoin option means that merchants using Square could potentially accept Bitcoin as a form of payment. The recent acquisition of the Bitlicense by Gemini and now Square shows that historically strict New York is moving in a more crypto-friendly direction</p>\n</div>",
              "feature_image": "/content/images/2018/06/unnamed-1-2.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-06-25T01:40:31.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-06-25T01:43:03.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-06-25T01:43:03.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Financial service provider Square has received a BitLicense from the New York Department of Financial Services and As a result, Bitcoin trading is now available to New York users of Square’s Cash App.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/square-gains-bitlicense/",
              "comment_id": "5b30480fded32719b2342a81"
          },
          {
              "id": "5b25cc02ded32719b2342a4e",
              "uuid": "afb9e1c1-26d8-4a2b-9606-84a40a49b5f4",
              "title": "Market Manipulation?",
              "slug": "market-manipulation",
              "html": "<div class=\"kg-card-markdown\"><p>What we know: It has been reported that the U.S. Commodity Futures Trading Commission (CFTC) demanded extensive trading data from several cryptocurrency exchanges in order to investigate whether there has been price manipulation in the crypto market. They are coordinating their investigation with the U.S. Department of Justice (DOJ). The probe followed the launch of BTC futures by CME Group. CME is regulated by the CFTC and generates its BTC futures prices based on data from four major crypto exchanges: Coinbase, Kraken, Bitstamp, Itbit, where manipulative trading might have altered the value of BTC futures.</p>\n<p>Spoofing and wash trading have been listed in similar context by the DOJ, spoofing is a process when a trader or group creates an order for a substantial amount of BTC or any commodity to form the illusion of exchange optimism or pessimism depending on their goals and then cancels it as someone puts an order to sell 2000 BTC to create panic among traders, rushing them to sell their stock before the price drops, effectively dropping the price. Despite what becomes uncovered, it’s clear the market is being manipulated in some way causing this bearish, sideways movement.</p>\n</div>",
              "feature_image": "/content/images/2018/06/unnamed-4.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-06-17T02:48:34.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-06-25T01:43:32.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-06-17T02:51:53.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "It has been reported that the U.S. Commodity Futures Trading Commission (CFTC) demanded extensive trading data from several cryptocurrency exchanges in order to investigate whether there has been price manipulation in the crypto market.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/market-manipulation/",
              "comment_id": "5b25cc02ded32719b2342a4e"
          },
          {
              "id": "5b23d4a6ded32719b2342a39",
              "uuid": "9fb43977-356b-41b6-b296-3eed971c8bb6",
              "title": "ETH Is Declared NOT To Be A Security",
              "slug": "eth-is-declared-not-to-be-a-security",
              "html": "<div class=\"kg-card-markdown\"><p>Ethereum (ETH) will not be regulated as a security under U.S. law. The SEC Corp. finance director stated “Based on my understanding of the present state of ether, the Ethereum network and its decentralized structure, current offers and sales of ether are not securities transactions.” BTC trading volumes of $5.1 bln over the 24-hour period, up from their weekly low of $3.8 bln, and Ethereum has seen a 10 percent rise in the 24 hour period, trading around 518$ currently.</p>\n</div>",
              "feature_image": "/content/images/2018/06/unnamed-3-1.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-06-15T15:00:54.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-06-15T15:02:54.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-06-15T15:02:54.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Ethereum (ETH) will not be regulated as a security under U.S. law. The SEC Corp. finance director stated “Based on my understanding of the present state of ether, the Ethereum network and its decentralized structure,",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/eth-is-declared-not-to-be-a-security/",
              "comment_id": "5b23d4a6ded32719b2342a39"
          },
          {
              "id": "5b23d3c4ded32719b2342a2b",
              "uuid": "78e1ad1d-1bd6-46af-aee2-55fe6ea644cc",
              "title": "E-Commerce Giant Plans To Issue Asset-Backed Securities",
              "slug": "e-commerce-giant-plans-to-issue-asset-backed-securities",
              "html": "<div class=\"kg-card-markdown\"><p>JD Finance, a subsidiary of Chinese e-commerce giant JD.com, has announced that it is planning to issue asset-backed securities (ABSs) on a blockchain. JD Finance established a partnership with Huatai Securities, a brokerage firm that will underwrite the issuance, as well as Xingye Bank, which will act as a trust. The aim is to issue the securities using a consortium blockchain that will see each party act as a node, recording the transactions in a transparent manner.</p>\n</div>",
              "feature_image": "/content/images/2018/06/unnamed-2-1.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-06-15T14:57:08.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-06-15T15:00:24.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-06-15T15:00:24.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "JD Finance, a subsidiary of Chinese e-commerce giant JD.com, has announced that it is planning to issue asset-backed securities (ABSs) on a blockchain. JD Finance established a partnership with Huatai Securities, a brokerage firm that will underwrite the",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/e-commerce-giant-plans-to-issue-asset-backed-securities/",
              "comment_id": "5b23d3c4ded32719b2342a2b"
          },
          {
              "id": "5b23d2baded32719b2342a1c",
              "uuid": "3b0bf20c-aa19-4b94-8c67-88a9258e0ab0",
              "title": "EOS Launches Its Own Blockchain",
              "slug": "eos-launches-its-own-blockchain",
              "html": "<div class=\"kg-card-markdown\"><p>EOS the fifth largest cryptocurrency, is set to launch its own blockchain today. This news comes a week after the EOS blockchain creator, Block.one released version 1.0 of blockchain protocol EOSIO. The EOSIO software is designed to let enterprise-level and community-driven businesses build scalable, blockchain-based applications.</p>\n</div>",
              "feature_image": "/content/images/2018/06/unnamed-1-1.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-06-15T14:52:42.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-06-15T14:54:22.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-06-15T14:54:22.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "EOS the fifth largest cryptocurrency, is set to launch its own blockchain today. This news comes a week after the EOS blockchain creator,",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/eos-launches-its-own-blockchain/",
              "comment_id": "5b23d2baded32719b2342a1c"
          },
          {
              "id": "5b230d55ded32719b2342a0e",
              "uuid": "00693d16-888d-4afa-a48f-8c795d6f361a",
              "title": "Alibaba Affiliate Raises Capital for Blockchain Technology",
              "slug": "alibaba-affiliate-raises-capital-for-blockchain-technology",
              "html": "<div class=\"kg-card-markdown\"><p>Ant Financial, the payment affiliate of Chinese internet giant Alibaba, announced it has raised $14 billion in a Series C round funding and will use that capital to further develop their blockchain technology. Founded in 2004 and formerly known as Alipay, Ant Financial’s goal is to offer inclusive financial services to the underbanked. This announcement is notable because the Alibaba affiliate is one of the most prominent payment providers in China, with an active user-base of over 800 million.</p>\n</div>",
              "feature_image": "/content/images/2018/06/unnamed-3.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-06-15T00:50:29.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-06-15T14:51:52.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-06-15T14:51:52.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Ant Financial, the payment affiliate of Chinese internet giant Alibaba, announced it has raised $14 billion in a Series C round funding and will use that capital to further develop their blockchain technology. ",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/alibaba-affiliate-raises-capital-for-blockchain-technology/",
              "comment_id": "5b230d55ded32719b2342a0e"
          },
          {
              "id": "5b1afbacded32719b23429f8",
              "uuid": "84f814ca-b869-4b07-bd5f-b43e2f7de89d",
              "title": "SAP Cloud Platform to Help Corporations Build Dapps",
              "slug": "sap-cloud-platform-to-help-corporations-build-dapps",
              "html": "<div class=\"kg-card-markdown\"><p>Software giant SAP has launched a cloud platform that is dedicated to helping corporates develop blockchain-based applications. The cloud-based solution aims to provide enterprises with framework to build business applications on top of blockchain systems such as Hyperledger Fabric, the blockchain platform launched by the Linux Foundation, of which SAP is also a main contributor. SAP has also announced it is forming a blockchain consortium, members of which are entitled to use tech developed by the group and includes firms such as HP enterprises, Intel, and UPS.</p>\n</div>",
              "feature_image": "/content/images/2018/06/unnamed-2.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-06-08T21:57:00.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-06-08T22:03:37.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-06-08T22:03:34.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Software giant SAP has launched a cloud platform that is dedicated to helping corporates develop blockchain-based applications. The cloud-based solution aims to provide enterprises with framework to build business applications on top of blockchain systems such as Hyperledger Fabric,",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/sap-cloud-platform-to-help-corporations-build-dapps/",
              "comment_id": "5b1afbacded32719b23429f8"
          },
          {
              "id": "5b1af882ded32719b23429ea",
              "uuid": "43410989-2484-4f86-b1b1-24fb1e627ee9",
              "title": "DHL Betting On Blockchain",
              "slug": "dhl-betting-on-blockchain",
              "html": "<div class=\"kg-card-markdown\"><p>DHL is partnering with blockchain trade finance platform TradeIX. The company has been looking to create more efficient networks through digitization, including a way to serialize products to be able to track that product through its life and they are turning to blockchain to do so. Blockchain technology can power leaner, more automated and error free processes and increased visibility.</p>\n</div>",
              "feature_image": "/content/images/2018/06/unnamed-1.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-06-08T21:43:30.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-06-08T21:45:48.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-06-08T21:45:48.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "DHL is partnering with blockchain trade finance platform TradeIX. The company has been looking to create more efficient networks through digitization, ",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/dhl-betting-on-blockchain/",
              "comment_id": "5b1af882ded32719b23429ea"
          },
          {
              "id": "5b1af7c0ded32719b23429da",
              "uuid": "3105fd4b-4754-428d-9b71-9a657c08f01d",
              "title": "Baidu Aims To Reduce Mining Energy",
              "slug": "baidu-aims-to-reduce-mining-energy",
              "html": "<div class=\"kg-card-markdown\"><p>Chinese internet giant Baidu has announced the integration of a protocol aimed at reducing mining energy consumption. The move is the latest in a series of increasingly direct experiments with cryptocurrency for Baidu, which launched its Blockchain-As-A-Service (BaaS) in January. The “Super Chain” can insert and remove consensus mechanisms to solve the current energy consumption problem and is also compatible with the development system of Bitcoin and Ethereum.</p>\n</div>",
              "feature_image": "/content/images/2018/06/unnamed.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-06-08T21:40:16.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-06-08T21:43:02.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-06-08T21:43:02.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Chinese internet giant Baidu has announced the integration of a protocol aimed at reducing mining energy consumption. The move is the latest in a series of increasingly direct experiments with cryptocurrency for Baidu, which launched its Blockchain-As-A-Service (BaaS) in January.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/baidu-aims-to-reduce-mining-energy/",
              "comment_id": "5b1af7c0ded32719b23429da"
          },
          {
              "id": "5b0cb9b2ded32719b23429b3",
              "uuid": "4073fab8-8b29-4bd2-8c0d-88807fb0317b",
              "title": "Coinbase Looks to Aquire Multiple Assets For Expansion",
              "slug": "coinbase-looks-to-aquire-multiple-assets-for-expansion",
              "html": "<div class=\"kg-card-markdown\"><p>Coinbase has met with US regulators to discuss applying for a banking license. Acquiring a banking license would expand the line of services that Coinbase could offer its customers and would remove the need to find a banking partner willing to work with a firm that offers cryptocurrency trading. It would also help them attract the attention of large institutions to its platform. Coinbase also announced it has acquired the exchange platform Paradex, which offers hundreds of coins for trading. This peer-to-peer trading removes the need for third-party custodianship and the associated security risks. It is another step toward creating a truly decentralized crypto economy.</p>\n</div>",
              "feature_image": "/content/images/2018/05/unnamed-11.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-05-29T02:23:46.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-29T02:28:29.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-05-29T02:28:29.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Coinbase has met with US regulators to discuss applying for a banking license.Coinbase also announced it has acquired the exchange platform Paradex, which offers hundreds of coins for trading.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/coinbase-looks-to-aquire-multiple-assets-for-expansion/",
              "comment_id": "5b0cb9b2ded32719b23429b3"
          },
          {
              "id": "5b04d97bded32719b234299d",
              "uuid": "651b85a8-fed3-4198-b802-e49f43112fbf",
              "title": "Former Visa CEO Moves To Crypto Startup",
              "slug": "former-visa-ceo-moves-to-crypto-startup",
              "html": "<div class=\"kg-card-markdown\"><p>Former Visa UK and Ireland CEO Marc O’Brien, has been appointed as the CEO of crypto startup Crypterium. Crypterium provides their users with a complete banking service. Unlike actual banks, Crypterium provides an instant processing engine that will work on both IOS and Android devices. The short-term strategy of the startup is to leverage the experience of O’Brien to secure a partnership with Visa or Mastercard and release cryptocurrency-backed debit cards.</p>\n</div>",
              "feature_image": "/content/images/2018/05/unnamed-23.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-05-23T03:01:15.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-23T03:04:23.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-05-23T03:04:23.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Former Visa UK and Ireland CEO Marc O’Brien, has been appointed as the CEO of crypto startup Crypterium. Crypterium provides their users with a complete banking service. Unlike actual banks, Crypterium provides an instant processing engine that will work on both IOS and Android devices.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/former-visa-ceo-moves-to-crypto-startup/",
              "comment_id": "5b04d97bded32719b234299d"
          },
          {
              "id": "5b04d8e7ded32719b234298e",
              "uuid": "52935e5d-cd64-419f-9dd9-fca7ae26a1e9",
              "title": "Walmart Files Patent For Blockchain-Based Marketplace",
              "slug": "walmart-files-patent-for-blockchain-based-marketplace",
              "html": "<div class=\"kg-card-markdown\"><p>Walmart has filed a patent for a blockchain-based marketplace for reselling purchased products. The proposed system would allow a customer to register the item after it's bought for the first time. The customer would then be able to choose a price for a resale, with the system itself acting as a digital marketplace. Walmart is just the latest giant to embrace the blockchain, mass adoption is coming along steadily.</p>\n</div>",
              "feature_image": "/content/images/2018/05/unnamed-22.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-05-23T02:58:47.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-23T03:00:45.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-05-23T03:00:45.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Walmart has filed a patent for a blockchain-based marketplace for reselling purchased products. The proposed system would allow a customer to register the item after it's bought for the first time.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/walmart-files-patent-for-blockchain-based-marketplace/",
              "comment_id": "5b04d8e7ded32719b234298e"
          },
          {
              "id": "5b04d818ded32719b234297c",
              "uuid": "3321c8e0-44d3-4a04-a54f-061595005248",
              "title": "Loopring- Decentralized Exchange And Open Protocol",
              "slug": "loopring-decentralized-exchange-and-open-protocol",
              "html": "<div class=\"kg-card-markdown\"><p>Loopring is a decentralized trading protocol that aims to allow users to trade assets with one another without the use of digital currency exchanges. Instead of depositing funds with a trusted third party, Loopring will allow users to leverage the protocol to find appropriate people to trade with. Working alongside other projects like Ethereum and Neo, Loopring has big plans for the future of trading. Keep a close eye on this one.</p>\n</div>",
              "feature_image": "/content/images/2018/05/unnamed-21.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-05-23T02:55:20.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-23T02:58:19.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-05-23T02:58:19.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Loopring is a decentralized trading protocol that aims to allow users to trade assets with one another without the use of digital currency exchanges. Instead of depositing funds with a trusted third party, Loopring will allow users to leverage the protocol to find appropriate people to trade with.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/loopring-decentralized-exchange-and-open-protocol/",
              "comment_id": "5b04d818ded32719b234297c"
          },
          {
              "id": "5b04d774ded32719b2342968",
              "uuid": "2a61a5aa-53fc-41b5-bc98-b84cfd47086d",
              "title": "Genesis Global Trading Earns Bitlicense",
              "slug": "genesis-global-trading-earns-bitlicense",
              "html": "<div class=\"kg-card-markdown\"><p>Genesis Global Trading has become just the fifth firm in the last three years to obtain a Bitlicense from the State Department of Financial services (DFS). Despite lacking a Bitlicense until this week, Genesis Global Trading had been operating in New York under a safe harbor provision. The market maker caters to high net worth and institutional investors and offers round-the-clock trading in bitcoin, bitcoin cash, ether, ethereum classic, XRP, litecoin and zcash. New York became the first state to craft a regulatory structure specifically for cryptocurrencies in 2014, and finalized the BitLicense in August 2015.</p>\n</div>",
              "feature_image": "/content/images/2018/05/unnamed-20.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-05-23T02:52:36.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-23T02:54:49.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-05-23T02:54:49.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Genesis Global Trading has become just the fifth firm in the last three years to obtain a Bitlicense from the State Department of Financial services (DFS). Despite lacking a Bitlicense until this week, Genesis Global Trading had been operating in New York under a safe harbor provision.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/genesis-global-trading-earns-bitlicense/",
              "comment_id": "5b04d774ded32719b2342968"
          },
          {
              "id": "5b04d3a6ded32719b2342959",
              "uuid": "96c018c8-5d92-479b-8315-cf51efa71658",
              "title": "Switzerland Looking To Launch State Cryptocurrency",
              "slug": "switzerland-looking-to-launch-state-cryptocurrency",
              "html": "<div class=\"kg-card-markdown\"><p>Switzerland is preparing to launch its own state cryptocurrency, called the E-franc.  Not so long ago the Swiss Central Bank had highlighted the instabilities of cryptocurrencies, but now the government is ready to take risks. It remains to be seen whether or not the final verdict will allow that to happen, but we should find out in the near future.</p>\n</div>",
              "feature_image": "/content/images/2018/05/unnamed-19.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-05-23T02:36:22.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-23T02:38:33.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-05-23T02:38:33.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Switzerland is preparing to launch its own state cryptocurrency, called the E-franc.  Not so long ago the Swiss Central Bank had highlighted the instabilities of cryptocurrencies, but now the government is ready to take risks.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/switzerland-looking-to-launch-state-cryptocurrency/",
              "comment_id": "5b04d3a6ded32719b2342959"
          },
          {
              "id": "5b04d2c9ded32719b234294c",
              "uuid": "3afd68b5-36af-4e25-8ab3-353a2f560f2a",
              "title": "Coinbase To Launch Prime",
              "slug": "coinbase-to-launch-prime",
              "html": "<div class=\"kg-card-markdown\"><p>Coinbase has announced it will be launching several new services aimed at institutional investors who are just getting started in crypto. Coinbase Custody is a service that provides specialist level services to allow institutions to hold bitcoin and other crypto with Coinbase. They have also announced a new platform for institutional customers called Prime. Prime is a customized trading service that will expand to also cover lending and margin financing services like OTC trading and algorithmic orders.</p>\n</div>",
              "feature_image": "/content/images/2018/05/unnamed-18.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-05-23T02:32:41.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-23T02:34:53.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-05-23T02:34:53.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Coinbase has announced it will be launching several new services aimed at institutional investors who are just getting started in crypto.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/coinbase-to-launch-prime/",
              "comment_id": "5b04d2c9ded32719b234294c"
          },
          {
              "id": "5b04d1daded32719b2342939",
              "uuid": "2577316a-9bb6-4675-96b3-8a10cac1897f",
              "title": "Nokia Partners With OSIsoft To Allow Users To Monetize Their Data",
              "slug": "nokia-partners-with-osisoft-to-allow-users-to-monetize-their-data",
              "html": "<div class=\"kg-card-markdown\"><p>Blockchain data platform Streamr is partnering with Finnish telecom giant Nokia and California software company OSIsoft to allow mobile customers to monetize their user data and make purchases. Participants buy and sell real-time data streams through ethereum smart contracts. Buyers and sellers use an ERC-20 token called DATAcoin. Customers will gain the ability to earn money for their operations data.</p>\n</div>",
              "feature_image": "/content/images/2018/05/unnamed-17.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-05-23T02:28:42.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-23T02:31:28.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-05-23T02:31:28.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Blockchain data platform Streamr is partnering with Finnish telecom giant Nokia and California software company OSIsoft to allow mobile customers to monetize their user data and make purchases.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/nokia-partners-with-osisoft-to-allow-users-to-monetize-their-data/",
              "comment_id": "5b04d1daded32719b2342939"
          },
          {
              "id": "5b04d112ded32719b2342928",
              "uuid": "8bc395e1-27ee-40d8-a8d6-41b89420e4f9",
              "title": "Circle Partners With Bitmain To Create Token Backed By USD",
              "slug": "circle-partners-with-bitmain-to-create-token-backed-by-usd",
              "html": "<div class=\"kg-card-markdown\"><p>Goldman Sachs backed Circle Internet Financial Ltd. a digital currency products developer has raised over 110 million in their fundraising round, led by hardware manufacturer Bitmain. The two are partnering to create a token which is backed by USD, and will aim to address the unstable nature of cryptocurrencies. The investment brings Circles’ valuation to nearly 3 billion, which is over 6 times higher than it was in 2016.</p>\n</div>",
              "feature_image": "/content/images/2018/05/unnamed-16.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-05-23T02:25:22.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-23T02:27:27.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-05-23T02:27:27.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Goldman Sachs backed Circle Internet Financial Ltd. a digital currency products developer has raised over 110 million in their fundraising round, led by hardware manufacturer Bitmain. ",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/circle-partners-with-bitmain-to-create-token-backed-by-usd/",
              "comment_id": "5b04d112ded32719b2342928"
          },
          {
              "id": "5b04d037ded32719b2342918",
              "uuid": "2d0b8332-65e3-4845-a2bb-67c65d443aab",
              "title": "Alphapoint To Launch Token Backed By Regulated Assets",
              "slug": "alphapoint-to-launch-token-backed-by-regulated-assets",
              "html": "<div class=\"kg-card-markdown\"><p>Crypto services firm Alphapoint has announced that they have launched the framework for blockchain tokens backed by regulated assets. They have launched their Regulated Asset Backed Token (RABT) in an effort seeking to put real estate on a blockchain. They developed software that allows the token to be freely traded, while also complying with securities laws. The hope is that using blockchain as a conduit will introduce more liquidity into the real estate market.</p>\n</div>",
              "feature_image": "/content/images/2018/05/unnamed-15.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-05-23T02:21:43.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-23T02:24:07.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-05-23T02:24:07.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Crypto services firm Alphapoint has announced that they have launched the framework for blockchain tokens backed by regulated assets. They have launched their Regulated Asset Backed Token (RABT) in an effort seeking to put real estate on a blockchain.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/alphapoint-to-launch-token-backed-by-regulated-assets/",
              "comment_id": "5b04d037ded32719b2342918"
          },
          {
              "id": "5b04cf23ded32719b2342908",
              "uuid": "30bdcb44-4136-49d8-8054-90c7ef52a3cb",
              "title": "ARK-All-In-One Blockchain Solutions",
              "slug": "ark-all-in-one-blockchain-solutions",
              "html": "<div class=\"kg-card-markdown\"><p>ARK provides users, developers, and startups with blockchain technologies. They aim to create an entire ecosystem of linked chains and a virtual spiderweb of endless use cases which make ARK highly flexible, adaptable, and scalable. Their network is one of the fastest in the industry and utilized a modified Delegated-Proof-Of-Stake (DPoS) consensus mechanism featuring 51 delegates. ARK is up 30% this week! It is currently trading at 46100 sats ($3.86 usd). It was due for a breakout, we’re long on ARK!</p>\n</div>",
              "feature_image": "/content/images/2018/05/unnamed-14.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-05-23T02:17:07.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-23T02:20:28.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-05-23T02:20:28.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "ARK provides users, developers, and startups with blockchain technologies. They aim to create an entire ecosystem of linked chains and a virtual spiderweb of endless use cases which make ARK highly flexible, adaptable, and scalable. ",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/ark-all-in-one-blockchain-solutions/",
              "comment_id": "5b04cf23ded32719b2342908"
          },
          {
              "id": "5b04ce28ded32719b23428f6",
              "uuid": "c5c1ccc2-eee3-4681-942d-f12ea52e3d32",
              "title": "Decentralized Exchanges",
              "slug": "decentralized-exchanges",
              "html": "<div class=\"kg-card-markdown\"><p>Decentralized exchanges are becoming more of a necessity. Any platform or app online is hackable, especially if the security measure taken are poor. Most crypto exchanges store a majority of their user funds in cold wallets or digital currency wallets not connected to the internet. Decentralized exchanges are the future, binance is currently working on one as well as another to watch out for in an upcoming ICO, Neonexchange (NEX). NEX is on the NEO blockchain and handles enormous volume, leverages an off-chain matching engine to enable faster and more complex trades across multiple blockchains. Token sale begins sometime in May (not official).</p>\n</div>",
              "feature_image": "/content/images/2018/05/unnamed-13.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-05-23T02:12:56.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-23T02:15:50.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-05-23T02:15:50.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Decentralized exchanges are becoming more of a necessity. Any platform or app online is hackable, especially if the security measure taken are poor.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/decentralized-exchanges/",
              "comment_id": "5b04ce28ded32719b23428f6"
          },
          {
              "id": "5b04ccb7ded32719b23428e6",
              "uuid": "65edb279-c5ee-4870-ba9e-238005e6d381",
              "title": "Facebook To Launch Its Own Virtual Currency?",
              "slug": "facebook-to-launch-its-own-virtual-currency",
              "html": "<div class=\"kg-card-markdown\"><p>Facebook is seriously considering launching its own virtual currency. If they do launch their own coin it would likely have the largest circulation of any virtual currency with a potential market of over 2 billion users. They have assembled an executive team to explore how to best leverage blockchain technology across Facebook. It is also ironic for such an anti-privacy giant to run something on a blockchain. Facebook is just the latest blue chip along with IBM and Microsoft to put serious thought into the blockchain.</p>\n</div>",
              "feature_image": "/content/images/2018/05/unnamed-12.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-05-23T02:06:47.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-23T02:11:10.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-05-23T02:11:10.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Facebook is seriously considering launching its own virtual currency. If they do launch their own coin it would likely have the largest circulation of any virtual currency with a potential market of over 2 billion users.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/facebook-to-launch-its-own-virtual-currency/",
              "comment_id": "5b04ccb7ded32719b23428e6"
          },
          {
              "id": "5b04cbd8ded32719b23428d5",
              "uuid": "b7d56fd9-266e-49c8-857f-14e59b768b29",
              "title": "Bloomberg To Launch Cryptocurrency Index",
              "slug": "bloomberg-to-launch-cryptocurrency-index",
              "html": "<div class=\"kg-card-markdown\"><p>One of bitcoin’s biggest bulls, billionaire Mike Novogratz and Bloomberg LP. have announced that they are teaming up to launch the Bloomberg Galaxy Cryptocurrency Index (BGCI) which will track the aggregate performance of the large-cap cryptocurrencies. When it comes to mass adoption it isn’t IF it’s WHEN. Don’t miss out!</p>\n</div>",
              "feature_image": "/content/images/2018/05/unnamed-10.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-05-23T02:03:04.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-23T02:05:23.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-05-23T02:05:23.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "One of bitcoin’s biggest bulls, billionaire Mike Novogratz and Bloomberg LP. have announced that they are teaming up to launch the Bloomberg Galaxy Cryptocurrency Index (BGCI)",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/bloomberg-to-launch-cryptocurrency-index/",
              "comment_id": "5b04cbd8ded32719b23428d5"
          },
          {
              "id": "5b04cadfded32719b23428c5",
              "uuid": "a926305f-4162-41c4-b5fe-bb43d725323b",
              "title": "Oracle Launching Platform For Decentralized Apps",
              "slug": "oracle-launching-platform-for-decentralized-apps",
              "html": "<div class=\"kg-card-markdown\"><p>Oracle Corp. the second largest software company in the world, will be launching blockchain products over the next 2 months. They announced they will unveil a platform-as-a-service product this month and decentralized ledger-based applications next month.</p>\n</div>",
              "feature_image": "/content/images/2018/05/unnamed-9.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-05-23T01:58:55.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-23T02:01:08.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-05-23T02:01:08.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Oracle Corp. the second largest software company in the world, will be launching blockchain products over the next 2 months.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/oracle-launching-platform-for-decentralized-apps/",
              "comment_id": "5b04cadfded32719b23428c5"
          },
          {
              "id": "5b04c8e1ded32719b23428b8",
              "uuid": "39297603-f3de-4f9c-85fe-2717b6439b6f",
              "title": "Goldman Sachs To Launch Bitcoin Trading",
              "slug": "goldman-sachs-to-launch-bitcoin-trading",
              "html": "<div class=\"kg-card-markdown\"><p>Goldman Sachs will finally launch their bitcoin trading operation after hiring their first cryptocurrency trader to open a bitcoin trading desk. It is expected to be up and running within a few weeks. The investment bank will likely wait until there is more regulatory certainty surrounding bitcoin to begin trading other virtual currencies/altcoins.</p>\n</div>",
              "feature_image": "/content/images/2018/05/unnamed-8.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-05-23T01:50:25.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-23T01:54:19.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-05-23T01:54:19.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Goldman Sachs will finally launch their bitcoin trading operation after hiring their first cryptocurrency trader to open a bitcoin trading desk.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/goldman-sachs-to-launch-bitcoin-trading/",
              "comment_id": "5b04c8e1ded32719b23428b8"
          },
          {
              "id": "5b04c724ded32719b23428a0",
              "uuid": "eb3d49ed-5833-40d9-ba25-c166ac4bb093",
              "title": "Car Giants Launch Blockchain Platform",
              "slug": "car-giants-launch-blockchain-platform",
              "html": "<div class=\"kg-card-markdown\"><p>Car giants BMW, GM, Ford, and others have launched their joint blockchain platform in an attempt to change transportation. In addition to them, the Mobility Open Blockchain Initiative (MOBI) is the brainchild of more than 30 participants including IBM, Hyperledger, and IOTA. Members will focus on using blockchain and related technologies to make mobility safer, greener, and more affordable.</p>\n</div>",
              "feature_image": "/content/images/2018/05/unnamed-7.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-05-23T01:43:00.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-23T01:45:55.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-05-23T01:45:55.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Car giants BMW, GM, Ford, and others have launched their joint blockchain platform in an attempt to change transportation.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/car-giants-launch-blockchain-platform/",
              "comment_id": "5b04c724ded32719b23428a0"
          },
          {
              "id": "5b04c3eeded32719b234288e",
              "uuid": "e10893a6-ad21-4a1f-ab50-284a15854cb3",
              "title": "SBI To Launch Country's First Bank-Owned Crypto Exchange",
              "slug": "sbi-to-launch-countrys-first-bank-owned-crypto-exchange",
              "html": "<div class=\"kg-card-markdown\"><p>Japanese banking giant SBI has confirmed the full-scale launch of SBI Virtual Currencies, in what will be the country’s first solely bank-owned cryptocurrency exchange. At launch SBI Virtual Currencies will support Bitcoin, Ripple, Ethereum, Bitcoin Cash, and other cryptos. The Banks are starting to see what we do.</p>\n</div>",
              "feature_image": "/content/images/2018/05/unnamed-6.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-05-23T01:29:18.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-23T01:32:27.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-05-23T01:32:27.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Japanese banking giant SBI has confirmed the full-scale launch of SBI Virtual Currencies, in what will be the country’s first solely bank-owned cryptocurrency exchange.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/sbi-to-launch-countrys-first-bank-owned-crypto-exchange/",
              "comment_id": "5b04c3eeded32719b234288e"
          },
          {
              "id": "5b04c21eded32719b2342883",
              "uuid": "b6104635-7919-4c8a-a896-a1456f5d4e3f",
              "title": "UNICEF-Using Cryptocurrency To Make A Difference",
              "slug": "unicef-using-cryptocurrency-to-make-a-difference",
              "html": "<div class=\"kg-card-markdown\"><p>UNICEF is mining cryptocurrency to raise funds for kids. Any cryptocurrency mined is turned into fiat currency and donated to UNICEF Australia to be used for help vulnerable children worldwide with life-saving supplies such as safe drinking water, food and vaccines. Cryptos are showing their versatility and making a difference in our world.</p>\n</div>",
              "feature_image": "/content/images/2018/05/unnamed-5.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-05-23T01:21:34.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-23T01:24:21.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-05-23T01:24:21.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "UNICEF is mining cryptocurrency to raise funds for kids.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/unicef-using-cryptocurrency-to-make-a-difference/",
              "comment_id": "5b04c21eded32719b2342883"
          },
          {
              "id": "5b04bdb2ded32719b234286a",
              "uuid": "d91ef7ee-d709-4f89-8ec8-54ba9cae1d30",
              "title": "Coinsource Bitcoin ATM Operator Expanding",
              "slug": "coinsource-bitcoin-atm-operator-expanding",
              "html": "<div class=\"kg-card-markdown\"><p>Coinsource, a U.S. Bitcoin ATM network has announced it will install 20 machines across the District of Columbia and Maryland after receiving significant demand from local users. Coinsource services 164 million residents across the country and currently has 182 machines in 19 states.</p>\n</div>",
              "feature_image": "/content/images/2018/05/unnamed-3.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-05-23T01:02:42.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-23T01:06:19.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-05-23T01:06:19.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": null,
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/coinsource-bitcoin-atm-operator-expanding/",
              "comment_id": "5b04bdb2ded32719b234286a"
          },
          {
              "id": "5b04b7dcded32719b2342847",
              "uuid": "02a5d0e6-d6f6-4de5-840e-de226be693ab",
              "title": "Central Bank Of Iran Bans Banks From Cryptocurrency",
              "slug": "central-bank-of-iran-bans-banks-from-cryptocurrency",
              "html": "<div class=\"kg-card-markdown\"><p>Iran’s central bank (CBI) has banned the country’s banks from offering services to crypto firms or dealing in cryptocurrencies over concerns about money laundering and terrorism. Another government in panic mode because their monopoly is in jeopardy, they will try to shut crypto down but it’s just simply not possible.</p>\n</div>",
              "feature_image": "/content/images/2018/05/unnamed.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-05-23T00:37:48.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-23T00:42:18.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-05-23T00:42:18.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Iran’s central bank (CBI) has banned the country’s banks from offering services to crypto firms or dealing in cryptocurrencies",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/central-bank-of-iran-bans-banks-from-cryptocurrency/",
              "comment_id": "5b04b7dcded32719b2342847"
          },
          {
              "id": "5ad3a74297444d05c23691d2",
              "uuid": "3e1a4628-0d57-40be-af52-fcc210f14676",
              "title": "Substratum & the Decentralized Web",
              "slug": "substratum-the-decentralized-web",
              "html": "<div class=\"kg-card-markdown\"><p>Substratum is an open-source network that allows anyone to allocate spare computing resources to make the internet a free and fair place for the entire world. It is a worldwide collection of nodes that securely delivers content without the need of VPN or Tor, and with net neutrality rules ending effectivley on April 23 there will be a void that Substratum would like to fill by providing the tools that anyone can use to help keep the internet accessible through decentralization. They believe information should be free and not locked down by censorship or net neutrality laws.</p>\n<p>The Substratum network as described by Justin Tabb is meant to solve most of the current issues facing the internet. Issues such as the internet becoming increasingly centralized, censored, and faces many controls. Data has to travel through designated servers or hubs which causes these access points to become targets for hackers or anyone seeking personal information. The network combines innovative technologies from the cryptocurrency and hosting realms to provide a free peer-to-peer internet and revolutionize the hosting industry. Security isn't an issue for their tech either. Privacy issues are resolved through advanced<br>\ncryptography algorithms rooted in Artificial Intelligence that ensure all data remains secure. All of this sounds great and if Substratum can deliver they will be a household name for the long term.</p>\n</div>",
              "feature_image": "/content/images/2018/04/image1.jpeg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": "Substratum & the Decntralized Web",
              "meta_description": "Substratum is an open-source network that allows anyone to allocate spare computing resources to make the internet a free and fair place for the entire world. ",
              "created_at": "2018-04-15T19:25:54.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-21T23:51:03.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-04-17T21:47:06.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Substratum is an open-source network that allows anyone to allocate spare computing resources to make the internet a free and fair place for the entire world. ",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/substratum-the-decentralized-web/",
              "comment_id": "5ad3a74297444d05c23691d2"
          },
          {
              "id": "5aba995593fe1b06d3faf1c5",
              "uuid": "c8c6708e-1ba0-48b1-8af2-80828282f953",
              "title": "Coinbase Makes Multiple Announcements: Markets Remain Idle",
              "slug": "coinbase-makes-multiple-announcements",
              "html": "<div class=\"kg-card-markdown\"><p>As of late, Coinbase has made multiple announcements concerning their improvements and advancements. With over 10 million users Coinbase has one of the largest userbases in the cryptospace, which is why their big announcements usually garner more of a reaction that is lacking from a currently stagnant market. Coinbase has raised more than $225 million in seed capital and there is a rumor that they are in talks to purchase startup Earn.com, which is an eponymous paid messaging platform. Earn.com is also in talks with multiple other parties believed to be &quot;household names&quot; in the industry.</p>\n<p>Also, they announced the release of a new gain/loss calculating tool to help the userbase keep up with U.S. tax requirements. The tool can be used to generate a report that outlines their capital gains (or losses) on its platform, using a first-in-first-out (FIFO) accounting method. This is mainly aimed at the users who have bought and sold on Coinbase exclusively, so not for the trader who has participated in ICO's or purchased digital assets elsewear.<br>\n<a href=\"https://www.coindesk.com/coinbase-eases-crypto-tax-procedure-with-gainloss-calculator/\">New gain/loss calculating tool</a></p>\n<p>The last announcement Coinbase rolled out was that they will begin supporting ethereum Erc-20 tokens. Erc-20 is the standard used by Ethereum tokens and smart contracts. It serves as an interface to which anyone wishing to issue a token or write a smart contract must comply. What does that mean? For most, they just ignore the news and say, oh great news. It's actually bad news for ETH — and another shorting opportunity if market realizes it. Why? Most of the recent Ether power was due to the fact it was needed for ICOs. Ethereum started dropping when the SEC regulation was announced. Now if coinbase starts accepting it, it's actually a weakening sign for Ethereum.  Not saying that the public will pick up on it however, this is something you should bear in mind when making decisions, read the implications, not the news.<br>\n<a href=\"https://verifiedtopics.com/coinbase-announces-support-for-ethereum-erc20-tokens/\">Erc-20 tokens</a></p>\n</div>",
              "feature_image": "/content/images/2018/04/coinbase-vs-gdax.png",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": "Coinbase announced the release of a new gain/loss calculating tool to help the userbase keep up with U.S. tax requirements. Also,they will begin supporting ethereum Erc-20 tokens. Erc-20 is the standard used by Ethereum tokens and smart contracts.",
              "created_at": "2018-03-27T19:19:49.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-21T23:50:02.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-03-29T21:35:49.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Coinbase announced the release of a new gain/loss calculating tool to help the userbase keep up with U.S. tax requirements. Also,they will begin supporting ethereum Erc-20 tokens. Erc-20 is the standard used by Ethereum tokens and smart contracts.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/coinbase-makes-multiple-announcements/",
              "comment_id": "5aba995593fe1b06d3faf1c5"
          },
          {
              "id": "5ab9468593fe1b06d3faf166",
              "uuid": "e7fb293b-29e4-4e75-b346-53322c62a292",
              "title": "Ripple In Trouble?",
              "slug": "ripple-in-trouble",
              "html": "<div class=\"kg-card-markdown\"><p>Ripple is back in the news again after a previous string of good news concerning partnerships, testing transactions with some big banks, etc. This news however seems to be not very positive and could be cause for alarm for many XRP HODLers. It seems as though the real fate of the cryptocurrency is solved in the judicial walls. Soon, the New York court will consider the claim of the company R3 against Ripple, following which R3 can receive 12.5% of the total volume of XRP, which is in circulation.</p>\n<p>The conflict between the companies began after they could not agree on a partnership. By that time, an agreement had already been signed, according to which R3 obtained the right to buy out 5 billion XRP tokens at a price of $ 0.0085 by the end of 2019. Ripple Labs tried to terminate the contract unilaterally, which led to a lawsuit from R3. Ripple filed a counterclaim in San Francisco, but the court rejected them.</p>\n<p>Now the last decision is up to the court in New York. If the decision is made in favor of R3, the company will receive 5 billion XRP tokens, which at current rates cost about $ 3.5 billion, at a price of only $ 42 million. In this case, the market will respond with a sharp drop in the cryptocurrency, which is now considered one of the most promising.</p>\n<p><a href=\"https://cointelegraph.com/news/r3-v-ripple-lawsuit-to-be-decided-in-ny-as-xrp-loses-its-appeal-to-ca-court\">Lawsuit info</a></p>\n</div>",
              "feature_image": "/content/images/2018/04/Ripple-vs-R3-Hearing-Will-Not-Be-Held-in-California-nn7qmz3hhtennsvtei1nqdg1wxu3gupv85tkgle04q.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": "Soon, the New York court will consider the claim of the company R3 against Ripple, following which R3 can receive 12.5% of the total volume of XRP, which is in circulation.",
              "created_at": "2018-03-26T19:14:13.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-21T23:49:19.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-03-27T17:39:08.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Soon, the New York court will consider the claim of the company R3 against Ripple, following which R3 can receive 12.5% of the total volume of XRP, which is in circulation.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/ripple-in-trouble/",
              "comment_id": "5ab9468593fe1b06d3faf166"
          },
          {
              "id": "5ab937c993fe1b06d3faf14d",
              "uuid": "7cfc9b81-0026-4577-acbc-c2952c2f33b2",
              "title": "Crypto Is Gaining Support from Some Big Names",
              "slug": "crypto-is-gaining-support-from-some-big-names",
              "html": "<div class=\"kg-card-markdown\"><p>For those who understand that crytocurrencies are here to stay, the reaction to some of the people who are spreading postive words about cryptocurrencies isn't the least bit surprising. First, we have Hedge fund billionaire Alan Howard who made sizable personal investments in cryptocurrencies last year and plans to put more of his own money into digital assets and the blockchain technology behind them, according to people with knowledge of the matter.</p>\n<p>Other partners at the hedge fund firm he co-founded, Brevan Howard Asset Management, have independently made similar investments, the people said, asking not to be named because the information isn’t public. The investments are separate from the $9.1 billion hedge fund firm, and Brevan Howard does not trade cryptocurrencies. Howard, 54, has already hired at least one person to work for him on initiatives in digital assets and plans to hire more. He could make private-equity style investments in blockchain companies and may participate in initial coin offerings.</p>\n<p>Next, we have billionaire co-founder of PayPal Peter Theil, who said &quot;There will be only one online equivalent to gold, and Bitcoin, as the biggest cryptocurrency, will triumph.&quot; He believes Cryptocurrency will end up as a store of value similar to gold rather than a currency or means for payment. As previously reported by CoinDesk in January, Founders Fund, of which Thiel is the co-founder, recently purchased between $15 million to $20 million worth of bitcoin across several of its funds.<br>\n<a href=\"https://www.coindesk.com/peter-thiel-bitcoin-will-one-online-equivalent-gold/\">Peter Theil</a></p>\n<p>Lastly, Twitter CEO and multi-millionaire Jack Dorsey made the claim that Bitcoin will be the world's &quot;Single Currency.&quot; He said &quot;The world ultimately will have a single currency, the internet will have a single currency. I personally believe that it will be bitcoin.&quot; Twitter became one of the first big names in the social media space to prohibit a range of cryptocurrency ads, and may ban ICO's and almost all cryptocurrency exchanges with the exception of a few.</p>\n<p><img src=\"/content/images/2018/03/image1.jpeg\" alt=\"image1\"></p>\n<p>This could be a postive for cryptocurrency as a whole because banning almost all ads will be able to cut down on the level of fraud that exists in the social media space concerning cryptocurrency, and would also explain why Dorsey appears very bullish on cryptocurrency. CoinDesk first reported that Dorsey had participated in a funding round that raised $2.5 million for Lightning Labs. The startup has notably just launched its beta version of the Lightning Network, a protocol layer built above the bitcoin blockchain to speed up the transaction process, as well as lower fees.<br>\n<a href=\"https://www.coindesk.com/peter-thiel-bitcoin-will-one-online-equivalent-gold/\">raised $2.5 million</a></p>\n<p>Despite there being a slight difference in opinion of what the future holds for Bitcoin and other cryptocurrencies, it would seem to be clear that cryptocurrencies aren't going anywhere anytime soon.</p>\n</div>",
              "feature_image": "/content/images/2018/04/What-Are-The-Best-Cryptocurrency-Trading-Platforms_1.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-03-26T18:11:21.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-21T23:44:01.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-03-26T19:12:18.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "For those who understand that crytocurrencies are here to stay, the reaction to some of the people who are spreading postive words about cryptocurrencies isn't the least bit surprising.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/crypto-is-gaining-support-from-some-big-names/",
              "comment_id": "5ab937c993fe1b06d3faf14d"
          },
          {
              "id": "5ab4295b93fe1b06d3faf142",
              "uuid": "2406d923-da95-4b3b-b774-3cebe7cafce4",
              "title": "Market Goes Green! - G20 Puts Regulation On Hold",
              "slug": "market-goes-green-g20-puts-regulation-on-hold",
              "html": "<div class=\"kg-card-markdown\"><p>At the G20 Summit in Buenos Aires, The Financial Stability Board (FSB) which coordinates financial regulation for the Group of 20 Economies resisted calls from some to regulate cryptocurrencies. The FSB, however, stressed the need for greater international coordination in monitoring these rapidly evolving technologies, which still represent a tiny sector equivalent to less than 1% of global gross domestic product (GDP).<br>\n<a href=\"https://www.forbes.com/sites/tedknutson/2018/03/19/cryptocurrency-doesnt-pose-a-risk-to-the-financial-system-yet-g20-told/#215712652d2c\">G20 Summit</a></p>\n<p>“Crypto-assets do not pose risks to global financial stability at this time” — Mark Carney, Chairman of the G20’s Financial Stability Board<br>\n<a href=\"https://ethereumworldnews.com/cryptocurrency-market-on-the-green-g20-puts-crypto-regulation-on-hold/\">Crypto-assets do not pose risks</a></p>\n<p>*** RESULTS***</p>\n<p>First conclusions of the G20 meeting for the purposes of the Cryptocurrency scenario, in case you are interested in:</p>\n<p>Argentina = Neutral<br>\nAustralia = Legal<br>\nBrazil = Legal<br>\nCanada = Legal<br>\nChina = Temporarily prohibited (illegal)<br>\nFrance = Legal<br>\nGermany = Legal<br>\nIndia = Neutral<br>\nIndonesia = Neutral<br>\nItaly = Legal<br>\nJapan = Legal<br>\nMexico = Restricted<br>\nRussia = Restricted (previously illegal until the recent unlocking of 40 encryption sites)<br>\nSaudi Arabia = Restricted<br>\nSouth Africa = Legal<br>\nSouth Korea = Restricted (Regulatory action previously legal but pending)<br>\nTurkey = Legal<br>\nUK = Legal<br>\nUS = Legal</p>\n<p>Countries invited for the 2018 G20 meeting:</p>\n<p>Chile = Legal<br>\nJamaica = Neutral<br>\nThe Netherlands = Legal<br>\nRwanda = Neutral<br>\nSenegal = Neutral<br>\nSingapore = Legal<br>\nSpain = Legal</p>\n<p>Total: 15 legal, 7 neutral, 4 Restricted,  1 illegal</p>\n</div>",
              "feature_image": "/content/images/2018/04/G20-crypto.jpeg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-03-22T22:08:27.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-21T23:32:07.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-03-22T22:47:42.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "At the G20 Summit in Buenos Aires, The Financial Stability Board (FSB) which coordinates financial regulation for the Group of 20 Economies resisted calls from some to regulate cryptocurrencies.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/market-goes-green-g20-puts-regulation-on-hold/",
              "comment_id": "5ab4295b93fe1b06d3faf142"
          },
          {
              "id": "5a9583aeb6a3a1542d4b95b6",
              "uuid": "4eae988e-baf0-41e3-885b-b38108c853e5",
              "title": "What is Bitcoin?",
              "slug": "what-is-bitcoin",
              "html": "<div class=\"kg-card-markdown\"><p>This is the first question almost everyone asks when exposed to the notion of cryptocurrency. We hear about it on the news, in our facebook feeds and, ever more commonly, as a payment method. We commonly hear about bitcoin being an impressive new technology or just some useless internet money, depending on who you listen to. But what is Bitcoin?</p>\n<p><strong>Ok, so what is Bitcoin?</strong><br>\nBitcoin is a computer network that stores and processes transactions from one 'person' to another. This network is highly decentralized having nodes all over the globe and <a href=\"https://www.coindesk.com/blockstream-using-satellites-beam-bitcoin-earth/\">even in space.</a>. These nodes communicate with eachother directly instead of talking to a central server - a technology called <a href=\"https://en.wikipedia.org/wiki/Peer-to-peer\">peer-to-peer or P2P</a>. P2P networks are difficult to shut down because there is no central point of failure; virtually anyone can run the bitcoin software on their own computer and become part of the network. Bitcoin uses <a href=\"https://en.wikipedia.org/wiki/Cryptography\">cryptography</a> in some very clever ways to solve a number of problems with traditional banking and payment processing systems. While Bitcoin was not the first of its kind, it introduced the novel idea of &quot;mining&quot; as a way of processing transactions, and if nothing else, was the first generally popular cryptocurrency.</p>\n<p>You can pay someone with bitcoin, you can hold it as an asset like a stock or you can use it for a myriad of financial vehicles like escrow and multi-tenant bank accounts. Bitcoin can't be physically held in your hand, rather, not as a shiny coin that has a <strong>B</strong> on it. Much in the same way you can't physically &quot;hold&quot; a share of Google stock but you can have a certificiate that says you own one, Bitcoin relies on the same principle. In a technical sense you must have access to unique cryptographic keys in order to spend and recieve Bitcoin. But generally most people use apps like a Wallet or Coinbase to make the process much easier and less technical.</p>\n<h1 id=\"whyusebitcoin\">Why use Bitcoin?</h1>\n<h1 id=\"howdoesbitcoinwork\">How does Bitcoin work?</h1>\n<p>The Bitcoin network does two main things: preserve and share the ledger of transactions, also called the <a href=\"https://en.wikipedia.org/wiki/Blockchain\">Blockchain</a>, and process transactions on the blockchain by means of decentralization and mining.</p>\n</div>",
              "feature_image": "/content/images/2018/05/471CABCE00000578-5161765-image-a-9_1512782532991.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-02-27T16:13:34.000Z",
              "created_by": "1",
              "updated_at": "2018-05-21T23:30:03.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-03-15T19:23:12.000Z",
              "published_by": "1",
              "custom_excerpt": "**Ok, so what is Bitcoin?**\nBitcoin is a computer network that stores and processes transactions from one 'person' to another.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "1",
              "primary_tag": null,
              "url": "/what-is-bitcoin/",
              "comment_id": "5a9583aeb6a3a1542d4b95b6"
          },
          {
              "id": "5aa3180193fe1b06d3faf12f",
              "uuid": "cd424916-cc0b-4f04-adb5-58c271ac2fb4",
              "title": "Cryptocurrency: Regulation Discussions",
              "slug": "cryptocurrency-regulation-discussions",
              "html": "<div class=\"kg-card-markdown\"><p>The most recent crypto price surge occured in an unregulated environment. In 2017 regulators began taking the first steps towards putting some restrictions on the market. These regulations are viewed as an attempt to slow down the explosive growth and bring some stability to an extremely volatile marketplace. News on these discussions of regulations has drawn mixed reactions from the market, with some countries discussing restrictions for exchanges and restricitons on crypto trading as a whole. The opening arguments to the ongoing discussion about how crypto should be recognized are only just beginning, but the picture is becoming more and more clear week after week that regulation is inevitable.</p>\n<p>Currently in the U.S. regulators seem to be on different wavelengths when it comes to bitcoin. The Securities and Exchange Commission (SEC) has not approved any exchange-traded products, holding cryptocurrencies, or any assets associated with cryptocurrency. They have also yet to register an Initial Coin Offering (ICO). In July of 2017 the SEC stated that ICO's can be fair and lawful invesment opportunites, but can also be used improperly. They also cracked down on fraud by issuing cease and desist notices to a few operations such as Bitconnect and USI Tech.</p>\n<p>The Commodity Futures Trading Commission (CFTC) has designated bitcoin as a commodity and stated any fraud or manipulation involving bitcoin traded in interstate commerce and regulation tied to commodity futures trading directly tied to bitcoin is under its authority. The CFTC allowed the CME and CBOE to launch bitcoin futures. They also approved a platform for trading and clearing of virtual currency derivatives for Ledger X llc. Ledger X is a clearing house that specializes in cryptocurrency derivatives.</p>\n<p>The Internal Revenue Service (IRS) says that bitcoin must be treated as property for tax purposes, which means a capital gain or loss should be recorded as if it were an exchange involving property. It should be treated as inventory if it is held for resale, and therefore and ordinary gain or loss should be recorded. If it is used as payment then it should be treated like currency, but must be converted at its fair market value.</p>\n<p>Several U.S. states are already pushing bills through congress to push for the recognition and adoption of bitcoin and the blockchain technology, while some have already passed them into law according to Bitcoin Magazine. Only time will tell what will happen with the regulation of cryptocurrency, but it is safe to say that it is inevitable that common ground will be found and that crypto and the blockchain are here for the long haul.</p>\n</div>",
              "feature_image": "/content/images/2018/03/1.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-03-09T23:25:53.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-21T23:26:10.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-03-10T01:45:27.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "In 2017 regulators began taking the first steps towards putting some restrictions on the market. These regulations are viewed as an attempt to slow down the explosive growth and bring some stability to an extremely volatile marketplace.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/cryptocurrency-regulation-discussions/",
              "comment_id": "5aa3180193fe1b06d3faf12f"
          },
          {
              "id": "5a92317eb6a3a1542d4b95ac",
              "uuid": "cebf74fb-d512-4258-854d-cae2a1afa8e1",
              "title": "Bitcoin Prediction 2018: Bitcoin could surge to 50k, $1 Trillion Market Cap",
              "slug": "bitcoin-prediction-2018-bitcoin-could-surge-to-50k-1-trillion-market-cap",
              "html": "<div class=\"kg-card-markdown\"><p>After surging to 20k in December of 2017 Bitcoin experienced a series of crashes to begin the new year. This pattern is not unfamiliar to the cryptocurrency market as over the past 3 years Bitcoin has experienced the same struggles throughout Q1. The history is an indicator that bitcoin will again recover and surge to new ATH's when the bulls decide to take back control of the market.</p>\n<p>Increasing regulatory recognition of cryptocurrency exchanges, the entrance of institutional capital and wall streets release of Bitcoin futures, and major technology developments will all be contributing factors in the recovery of bitcoin and ultimately the rerise of Bitcoin to new ATH's.</p>\n<p><a href=\"https://www.cnbc.com/2018/02/07/bitcoin-price-could-hit-50000-this-year-experts-say.html\">Bitcoin price prediction</a></p>\n</div>",
              "feature_image": "/content/images/2018/05/bitcoin-btc-cryptocurrency-overstock-ethereum-2.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-02-25T03:46:06.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-21T23:08:38.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-02-25T04:18:47.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "After surging to 20k in December of 2017 Bitcoin experienced a series of crashes to begin the new year. This pattern is not unfamiliar to the cryptocurrency market as over the past 3 years Bitcoin has experienced the same struggles throughout Q1.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/bitcoin-prediction-2018-bitcoin-could-surge-to-50k-1-trillion-market-cap/",
              "comment_id": "5a92317eb6a3a1542d4b95ac"
          },
          {
              "id": "5a9226e5b6a3a1542d4b95a6",
              "uuid": "81158e85-c2c1-4d08-b7e5-867dcc66deed",
              "title": "RippleNet Partners with Chinese-Based Payment Service Provider LianLian",
              "slug": "ripplenet-partners-with-chinese-based-payment-service-provider-lianlian",
              "html": "<div class=\"kg-card-markdown\"><p>On February 7, 2018 RippleNet announced a partnership with Chinese-based payment service provider LianLian International. RippleNet is Ripple(XRP)'s decentralized global network which hopes to provide faster and less expensive cross-border transactions throughout the US, Europe, China.</p>\n<p><a href=\"https://cointelegraph.com/news/ripples-global-financial-network-partners-with-china-based-payment-provider\">Lian Lian-ripplenet partnership</a></p>\n</div>",
              "feature_image": "/content/images/2018/05/chinas-fourth-largest-payment-network-lianlian-joins-ripple.png",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-02-25T03:00:53.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-21T23:06:38.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-02-25T03:23:29.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "On February 7, 2018 RippleNet announced a partnership with Chinese-based payment service provider LianLian International. RippleNet is Ripple(XRP)'s decentralized global network which hopes to provide faster and less expensive cross-border transactions throughout the US, Europe, China.",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/ripplenet-partners-with-chinese-based-payment-service-provider-lianlian/",
              "comment_id": "5a9226e5b6a3a1542d4b95a6"
          },
          {
              "id": "5a860d5eb6a3a1542d4b959c",
              "uuid": "68104e68-fdba-42b0-aa44-b2891ed80fd9",
              "title": "Getting Started",
              "slug": "getting-started-investing-trading-cryptocurrency",
              "html": "<div class=\"kg-card-markdown\"><p>How to Get Started with Investing/Trading Cryptocurrency.</p>\n<p>The first step to take when starting off in the world of Cryptocurrency is TO DO YOU'RE OWN RESEARCH! Take the time to learn about what you are about to invest your money in, basic knowledge can go a long way.</p>\n<p>In order to get started in world of Cryptocurrency you will need to create an account and an online wallet on <a href=\"http://\">www.coinbase.com</a>. And also download the Coinbase mobile app. Coinbase  is a secure online platform for buying, selling, transferring, and storing digital currency. From here you can purchase Bitcoin, Ethereum, Bitcoin cash, and Litecoin. To create an account click sign up and type in your email address, a custom password, and solve the capcha to prove you’re not a bot and youre good to go. There is a 2-factor authentication on all coinbase accounts that will require you to type in the 6 digit code that will come in the form of a text message before you can login. Also for the mobile app you will be required to provide a 4 digit pin number to log into the app.</p>\n<p>Once you have created the account you will need to link either your bank account or debit/credit card or both so you can begin to purchase and transfer crypto. Credit/debit transactions are virtually instant, but bank transfers could take up to 5-7 business days to process. Coinbase charges a flat fee of 1.49% on all bank account transactions and 3.99% fee on credit/debit purchases. Once you have purchased the cryptocurrency you can then transfer to what are called Exchanges. An exchange is a place where you can buy and sell Bitcoin, Litecoin, Ethereum, Bitcoin cash, and all other types of what are called Alt coins or alternate coins. Once an account is created on an exchange you will then be able to send cryptocurrency from your online coinbase wallet to your online wallet on the exchange of your choosing. Creating an account on an exchange is simple, they also offer 2 factor authentication which will add a layer of security to your coins. However even with 2 factor authentication these exchanges aren’t the safest place to store your coin holdings. There are a few ways to store your coins either in an offline wallet in cold storage, or in specific online wallets designed for individual coins such as altcoin wallets. Neo, Electroneum, Cardano, and many others have online mobile wallets to store coins safely, but at the end of the day the choice is yours whether you’re a HODLer or a day trader.</p>\n<p>List of top 40 exchanges<br>\n<a href=\"http://\">https://www.bestbitcoinexchange.io/</a></p>\n<p>Now that you have an online wallet with Coinbase, and your accounts with online exchanges are set up you will need to download a mobile portfolio and real time statistics app to follow the coins that you may want to invest in or have already invested in. you can track real time price changes in all markets and also keep track of the overall value of your own portfolio of the coins that you possess.</p>\n<p>From here, you now have created your online wallet with Coinbase.com with which you can purchase Bitcoin, Ethereum, Bitcoin Cash, and Litecoin. You also now have created your accounts on the exchanges of your choice. You are now ready to begin investing into major cryptocurrencies and or converting those major cryptos into altcoins. Remember you can send and receive coins from any exchange as long as you make sure you use the correct wallet address that pertains to your wallet and the coin you are trying to transfer. ALWAYS double check before finalizing transactions, you don’t want to lose your coins because you made a mistake.</p>\n</div>",
              "feature_image": "/content/images/2018/05/bitcoin-btc-cryptocurrency-overstock-ethereum-1.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-02-15T22:44:46.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-21T23:04:20.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-02-15T22:48:16.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "In order to get started in world of Cryptocurrency you will need to create an account and an online wallet on [www.coinbase.com](http://). And also download the Coinbase mobile app. Coinbase  is a secure online platform for buying, selling, transferring, and storing digital currency. ",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/getting-started-investing-trading-cryptocurrency/",
              "comment_id": "5a860d5eb6a3a1542d4b959c"
          },
          {
              "id": "5a860c42b6a3a1542d4b959b",
              "uuid": "68bc325b-5b25-4102-98b0-87ccfe8f3391",
              "title": "List of Largest Bitcoin Crashes",
              "slug": "list-of-largest-bitcoin-crashes",
              "html": "<div class=\"kg-card-markdown\"><ul>\n<li>\n<p>94% June-November 2011 from $32 to 2$ because of MtGox hack.</p>\n</li>\n<li>\n<p>36% June 2012 from 7$ to 4$ Linod hack</p>\n</li>\n<li>\n<p>79% April 2013 from $266 to $54 because MtGox stopped trading.</p>\n</li>\n<li>\n<p>49% February 2014 MtGox is gone.</p>\n</li>\n<li>\n<p>40% September 2017 from $5,000 to $2,972 because of China cryptocurrency ban.</p>\n</li>\n<li>\n<p>55% January 2018 from $19,700 to $14,500 because of Korea FUD.</p>\n</li>\n<li>\n<p>41% February 2018 from $14,500 to $8,500 because of India FUD.</p>\n<p>After every one of these crashes, Bitcoin and cryptocurrency as a whole have always recovred in the past. Bitcoin seems to have been following very similar trends over the past three years. So, as we begin to recover from the most recent barrage of FUD we wait for the whales and institutional money to flow into the market and revive the king. Below is a comparison of the charts ranging back to 2015.</p>\n</li>\n</ul>\n<p><img src=\"/content/images/2018/02/IMG_1537.PNG\" alt=\"IMG_1537\"></p>\n</div>",
              "feature_image": "/content/images/2018/05/images.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": null,
              "meta_description": null,
              "created_at": "2018-02-15T22:40:02.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-21T23:00:52.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-02-15T22:41:55.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "Largest bitcoin crashes from 2011 to present. ",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/list-of-largest-bitcoin-crashes/",
              "comment_id": "5a860c42b6a3a1542d4b959b"
          },
          {
              "id": "5a860735b6a3a1542d4b959a",
              "uuid": "d487b270-a479-4d5a-a8c2-06df162cb1a0",
              "title": "Graphs, Terms, and Analysis",
              "slug": "graphs-terms-analysis",
              "html": "<div class=\"kg-card-markdown\"><p><strong>Bullish Trend</strong>-in a secular Bull market the prevailing trend is upward-moving.</p>\n<p><strong>Bearish Trend</strong>-In a secular Bear market the prevailing trend is downward-moving.</p>\n<p><strong>Bullish Flag</strong> patterns are found in coins with strong uptrend. It forms a flagpole, the pole is the result of a vertical rise in price and the flag results from a period of consolidation. Can be horizontal, but is usually angled down. The breakout from a flag often results in a powerful move higher.</p>\n<p><strong>Bullish Pennant</strong> patterns are very similar to flag patterns. The pennant in consolidation will form a symmetrical triangle, also indicating the start of a powerful move higher upon breakout.</p>\n<p><strong>The Cup with Handle</strong>-is a bullish continuation pattern that marks a period of consolidation followed by a breakout. The cup forms after an advance and looks like a bowl or rounding bottom. As the cup is completed a trading range develops on the right side and the handle is formed. A breakout from the handles trading range is a signal of a powerful move upward.</p>\n<p><strong>The Symmetrical Triangle</strong>-usually forms as a continuation pattern containing at least 2 lower highs and 2 higher lows. When these points are connected continuing lines take the shape of the symmetrical triangle. There are instances where the triangles mark important trend reversals, they most often represent a continuation of the current trend.</p>\n<p><strong>The Ascending Triangle (or right triangle)</strong>-is a bullish pattern that forms during an uptrend as a continuation pattern. Regardless of where they are formed these bullish formations indicate accumulation. 2 or more equal highs form a horizontal line at the top. 2 or more rising bottoms form an ascending line that forms the right triangle.</p>\n<p><strong>Consolidation</strong>-is used to describe the movement of a coins price within a well-defined pattern of trading levels and is regarded as a period of indecision.</p>\n<p><strong>Accumulation</strong>-is a momentum indicator that determines the buyers are buying,  accumulating, or distributing (selling) by identifying divergence between price and volume.</p>\n<p><strong>Long Position</strong>-is the buying of a cryptocurrency with the expectation that the asset will rise in value.</p>\n<p><img src=\"/content/images/2018/02/IMG_1676.JPG\" alt=\"IMG_1676\"></p>\n<p><strong>Trading Volume</strong>-plays an important role in identifying trends, significant trends are usually accompanied by high trading volume, and weak trends are accompanied by low volume. When a coin goes down it is advisable to check the volume that accompanied the decline. A long-term trend of healthy growth is accompanied by a high volume of increases and a low volume of declines. It is also important to see that volume is rising over time. If the volume is decreasing during increases, the upward trend is likely to come to an end.</p>\n<p><strong>Trend lines</strong>-The typical direction that a coin is moving towards, can be most beneficial for traders of crypto. Technicians understand that they can overlook the volatility and find an upward trend upon seeing a series of higher highs, and vice versa. Additionally, there are trends that move sideways, and in these cases, a coin doesn’t move significantly in either direction. Traders should be mindful that trends come in many forms, including intermediate, long and short-term trend lines.</p>\n<p><strong>Moving Average</strong>-used to simplify trend recognition, is based on the average price of a coin over a certain period of time.</p>\n<p><strong>Resistance and support</strong>-These horizontal lines express support and resistance levels, by identifying these values we can determine the supply and demand of the coin.</p>\n<p><strong>Support Lines</strong>-lines expressing a level of support show that there seems to be a sizeable amount of traders who are willing to buy the coin (high demand). Those traders feel the current price of the coin is low and will seek to buy, once the price gets close to this point a “floor” of buyers is created causing the decline to stop and sometimes reversing into an uptrend (bouncing off support).</p>\n<p><strong>Resistance Lines</strong>-This is an area where many sellers wait with their sell orders forming a large supply zone. Every time a coin approaches that “ceiling” the supply stacks and it goes back.</p>\n<p><img src=\"/content/images/2018/02/eng_resistanceH1.jpg\" alt=\"eng_resistanceH1\"></p>\n<p><strong>Double Bottom</strong>-A double bottom appears when a trade is already in a downtrend, it finds a support and bounces. After bounce typical retracement happens as the bears continue the downtrend but the second attempt has nowhere to go, this is where the buyers enter and establish a support level. As buying pressure increases, the previous “swing high” is broken and a double bottom is confirmed and a breakout occurs. This type of trade happens frequently and is one of the most common patterns you will find.</p>\n<p><strong>Trading session</strong>- is a period of time consisting of one day of business in a financial market, from the opening bell to the closing bell.</p>\n<p><img src=\"/content/images/2018/02/trading-charts-5-560x467.jpg\" alt=\"trading-charts-5-560x467\"></p>\n<p><strong>Candlesticks</strong>-include open, high, low, and close values for each period you want to display. The hollow or filled portion of the candlestick is “the body”. The long thin lines above and below represent the high and low range and are called “shadows”.</p>\n<p><img src=\"/content/images/2018/02/IMG_1675.JPG\" alt=\"IMG_1675\"></p>\n<p><strong>The Hammer</strong>-is a bullish reversal pattern that signals that the coin is nearing the bottom of a downtrend. The body of the candle is short with a long lower shadow which shows that sellers are driving the price down during the trading session, only to be followed by strong buying pressure.</p>\n<p><strong>The Inverted Hammer</strong>-also forms in a downtrend and is a likely signal of a reversal or support. Its identical to the hammer accept a longer upper shadow indicates buying pressure after the price opening mixed with selling pressure that isn’t enough to drive the price down below opening value.</p>\n<p><strong>The bullish engulfing pattern</strong>-is a 2 candle reversal pattern. The second candle completely engulfs the real body of the previous candle, it appears in a downtrend and is a combination of a green candle followed by a larger red candle. It is advisable to enter a long position once the price goes over the high point of the second candle which is a confirmation of downtrend reversal.</p>\n<p><strong>The Morning Star</strong>-is a sign of hope in a gloomy downtrend that consists of 3 candles, one short-bodied candle (called a doji or a spinning top) between a preceding long red candle and a succeeding long green one.</p>\n<p><strong>The Three White Soldiers</strong>-It consists of three long white candles that close progressively higher on each subsequent trading day. Each candle opens higher than then previous open and closes near the high of the day, showing a steady advance of buying pressure. Investors should exercise caution when white candles appear to be too long as that may attract short sellers and push the price of the stock further down.</p>\n<p><strong>Three Black Crows</strong>-bearish reversal pattern occurring at the top of an uptrend, with three black bars posting lower lows that close near intrabar lows. This pattern predicts that the decline will continue to even lower lows, perhaps triggering a broader-scale downtrend. The most bearish version starts at a new high (point A on the chart) because it traps buyers entering momentum plays.</p>\n<p><strong>The Evening Star</strong>-a bearish reversal pattern starts with a tall white bar that carries an uptrend to a new high. The market gaps higher on the next bar, but fresh buyers fail to appear, yielding a narrow range candlestick. A gap down on the third bar completes the pattern, which predicts that the decline will continue to even lower lows, perhaps triggering a broader-scale downtrend.</p>\n<p><strong>Spinning Top</strong>-a type of candlestick formation where the real body is small despite a wide range of price movement throughout the trading day. This candle is often regarded as neutral and used to signal indecision about the future direction of the underlying asset.</p>\n<p><strong>Doji</strong>-are candlesticks look like a cross, inverted cross or plus sign. Alone, doji are neutral patterns that are also featured in a number of important patterns. A doji candlestick forms when a coin’s open and close are virtually equal for the given time period and generally signals a reversal pattern for technical analysts.</p>\n<p><strong>Shooting Star</strong>-is a type of candlestick formation that results when a security's price, at some point during the day, advances well above the opening price but closes lower than the opening price. For a candlestick to be considered a shooting star, the formation must be on an upward or bullish trend, and the distance between the highest price for the day and the opening price must be more than twice as large as the shooting star's body. The distance between the lowest price for the day and the closing price must be very small or nonexistent.</p>\n<p><strong>Sell wall / Buy wall</strong>-Using a depth chart, traders can see the current limit buy and sell points.</p>\n<p><a href=\"http://www.google.com\">Google Link</a></p>\n<p><img src=\"/content/images/2018/02/image-1.png\" alt=\"image-1\"></p>\n</div>",
              "feature_image": "/content/images/2018/05/DQmTnc7m9FPL8QGM77rfBzyai8aUZQYnCTiFLNUtyqBR5rS.jpg",
              "featured": false,
              "page": false,
              "status": "published",
              "locale": null,
              "visibility": "public",
              "meta_title": "",
              "meta_description": "Tehrwerknwer",
              "created_at": "2018-02-15T22:18:29.000Z",
              "created_by": "5a5e1ac1dedfa50ada63e0f1",
              "updated_at": "2018-05-22T00:41:06.000Z",
              "updated_by": "5a5e1ac1dedfa50ada63e0f1",
              "published_at": "2018-02-15T22:38:43.000Z",
              "published_by": "5a5e1ac1dedfa50ada63e0f1",
              "custom_excerpt": "**Bullish Trend**-in a secular Bull market the prevailing trend is upward-moving.\n\n**Bearish Trend**-In a secular Bear market the prevailing trend is downward-moving.\n\n**Bullish Flag** patterns are found in coins with strong uptrend. It forms a flagpole, the pole is the result of a vertical rise \n",
              "codeinjection_head": "",
              "codeinjection_foot": "",
              "og_image": null,
              "og_title": null,
              "og_description": null,
              "twitter_image": null,
              "twitter_title": null,
              "twitter_description": null,
              "custom_template": null,
              "author": "5a5e1ac1dedfa50ada63e0f1",
              "primary_tag": null,
              "url": "/graphs-terms-analysis/",
              "comment_id": "5a860735b6a3a1542d4b959a"
          }
      ],
      "meta": {
          "pagination": {
              "page": 1,
              "limit": "all",
              "pages": 1,
              "total": 47,
              "next": null,
              "prev": null
          }
      }
  }
}



// WEBPACK FOOTER //
// ./src/components/glossary/glossary.ts